import $ from 'jquery';
import BaseProduct from './base';
//import Gallery from '../gallery';
import AjaxAdd from '../ajax-add';

const selectors = {
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
};

const SimpleProduct = {
  onLoad() {
    this.init();

    //this.gallery = new Gallery(this.childConfig);
    this.ajaxCart = new AjaxAdd(this.childConfig);

    this.customBind();
  },

  customBind() {
    this.$container.on(
      `variantChange${this.namespace}`,
      this.updateAddToCartState.bind(this),
    );
  },

  /**
   * Updates the DOM state of the add to cart button
   */
  updateAddToCartState(event) {
    const {variant} = event;
    const $addToCart = $(selectors.addToCart, this.$container);
    const $cartText = $(selectors.addToCartText, this.$container);

    if (!variant) {
      $addToCart.prop('disabled', true);
      $cartText.html(theme.strings.addToCart);
      return;
    }

    if (variant && variant.available) {
      $addToCart.prop('disabled', false);
      $cartText.html(theme.strings.addToCart);
    } else {
      $addToCart.prop('disabled', true);
      $cartText.html(theme.strings.soldOut);
    }
  },
};

export default Object.assign(BaseProduct, SimpleProduct);
